import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateProjectPersonnelBulkDestructionMutation({
  projectId,
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ projectPersonnelIds }) => {
      const response = await axios.post(
        `/projects/${projectId}/project_personnel/bulk_destructions`,
        { bulk_destruction: { project_personnel_ids: projectPersonnelIds } },
      );

      return response.data;
    },
    onSuccess: () => {
      [
        'assignablePersonnelSearches',
        'companyRoleSearches',
        'projectPersonnel',
        'signatureStatus',
        'teamSearches',
      ].forEach((queryKeySegment) =>
        queryClient.invalidateQueries(['projects', projectId, queryKeySegment]),
      );
    },
  });
}
